export const PUBLIC_APP_ORIGIN = "https://courtvibe.app";

function publicUrl(pathname: string): string {
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${PUBLIC_APP_ORIGIN}${path}`;
}

export function leagueInviteUrl(inviteCode: string): string {
  return publicUrl(`/join/${encodeURIComponent(inviteCode)}`);
}

export function leagueCallupUrl(leagueId: string, callupId: string): string {
  return publicUrl(
    `/leagues/${encodeURIComponent(leagueId)}/callups/${encodeURIComponent(callupId)}`,
  );
}